import { Button, Card, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TaxonomySelector } from 'app/components/form-controls/taxonomy-selector';
import { GeneralConstants } from 'app/constants/general-constants';
import { selectActiveTaxonomies, selectAvailableTaxonomies, setActiveTaxonomies } from 'features/auth/auth.slice';

interface TaxonomyChooserProps {
    compact: boolean;
}

export const TaxonomyChooser: React.FunctionComponent<TaxonomyChooserProps> = ({ compact }) => {
    const [isCompact, setCompact] = useState(compact);
    const activeTaxonomies = useSelector(selectActiveTaxonomies);
    const available = useSelector(selectAvailableTaxonomies);
    const dispatch = useDispatch();

    const names = activeTaxonomies?.map(({ name }) => name).join(', ') || 'NONE';

    if (1 >= available.length) {
        return GeneralConstants.RENDER_NOTHING;
    }

    if (isCompact) {
        return (
            <Tooltip title='Taxonomy Selector'>
                <Button variant='outlined' color='inherit' className='ml-2' onClick={() => setCompact(false)}>
                    <small>
                        TXN:
                        <br />
                        {names}
                    </small>
                </Button>
            </Tooltip>
        );
    }

    return (
        <Card className='ml-2'>
            <TaxonomySelector
                openOnFocus
                autoFocus
                disableClearable
                color='inherit'
                variant='outlined'
                size='small'
                className='m-1'
                sx={{ width: 200 }}
                onChange={(evt, value) => {
                    if (0 === value.length) {
                        return;
                    }
                    let allSelected = false;
                    if (
                        value.find(({ id }) => {
                            return 'all' === id;
                        })
                    ) {
                        allSelected = true;
                    }

                    dispatch(setActiveTaxonomies(allSelected ? available : value));
                    if (allSelected) {
                        window.location.reload();
                        setCompact(true);
                    }
                }}
                onClose={() => {
                    window.location.reload();
                    setCompact(true);
                }}
                value={activeTaxonomies}
            />
        </Card>
    );
};
